module.exports = __webpack_public_path__ + "static/media/LG_AMB.8243c4a9.mp3";